import scrollLock from 'scroll-lock';

export default class Accordion {
	static init(){
		const accordionWrapper = document.querySelector('.accordion');
		new Accordion(accordionWrapper);
	}

	constructor(accordionWrapper){

		this.accordionWrapper = accordionWrapper;

		if (!this.accordionWrapper) {
			return;
		}

		this.button = this.accordionWrapper.querySelector('.toggle-panel');
		this.buttonModal = this.accordionWrapper.querySelector('.toggle-panel--mobile');
		this.panel = this.accordionWrapper.querySelector('.panel-body');
		this.closeButtons = this.accordionWrapper.querySelectorAll('.close-panel-js');

		this.panelOpen = false;

		this.button.addEventListener('click', e => {
			this.togglePanel();
		});

        this.buttonModal.addEventListener('click', e => {
			this.togglePanel();
		});

        this.closeButtons.forEach(button => {
            button.addEventListener('click', e => {
                this.togglePanel();
                e.preventDefault();
            });
        });
	}

	togglePanel() {
		this.panelOpen ? this.closePanel() : this.openPanel();
	}

	openPanel() {
		this.panelOpen = true;
		this.panel.classList.add('active');

		if (window.innerWidth < 768) {
			scrollLock.disablePageScroll();
		}

		this.button.classList.add('is-open');
		this.button.setAttribute('aria-expanded', true);
		this.button.setAttribute('aria-label', 'sluit filter');
	}

	closePanel() {
		this.panelOpen = false;

		this.panel.classList.remove('active');

		if (window.innerWidth < 768) {
			scrollLock.enablePageScroll();
		}

		this.button.classList.remove('is-open');
		this.button.setAttribute('aria-expanded', false);
		this.button.setAttribute('aria-label', 'open filter');
	}
}
